import Checkbox from "antd/lib/checkbox";

export default Checkbox;
